module.exports = __webpack_public_path__ + "static/media/1.913ab94e.jpg";